import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UpdatePasswordService} from '../service/update-password.service';
import {lastValueFrom} from 'rxjs';
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {RequestPasswordUpdateOTP} from "@ui-kit/framework/security/model/request-password-update-otp.model";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  public loading = false;
  public errorMsg = null;

  forgotPasswordForm = new FormGroup({
    email: new FormControl(null, {
      validators: [Validators.required, Validators.email]
    })
  });

  constructor(private router: Router,
              private route: ActivatedRoute,
              private updatePasswordService: UpdatePasswordService,
              public loader: LoadingService) {
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.valid) {
      const otpRequest: RequestPasswordUpdateOTP = new RequestPasswordUpdateOTP({
        email: this.email!.value
      });

      this.updatePasswordService.setContext(this.forgotPasswordForm.value);
      this.loading = true;
      let clientId = this.route.snapshot.paramMap.get('clientId');

      lastValueFrom(this.updatePasswordService.requestForgotPasswordOTP(otpRequest))
        .then(res => {
            this.loading = false;
            this.router.navigate([`${clientId}/forgot-password/check-your-email`])
              .catch((reason: string) => {
                console.log(reason)
              });
          },
          err => {
            this.loading = false;
            console.log(err);
            if ('ValidationException' === err.headers.get('error_code')) {
              this.errorMsg = err.headers.get('error_message');
            }
          });
    } else {
      this.forgotPasswordForm.get('email')?.setErrors({'pattern': true});
    }
  }

  get email() {
    return this.forgotPasswordForm.get('email');
  }
}
